import { combineReducers } from "redux"
import { chain } from "lodash"

const reducers = chain(require.context(".", false, /^\.\/[^/]+\.[jt]sx?$/).keys())
  .map(id => [id, require(`${id}`).reducer])
  .filter(([, reducer]) => !!reducer)
  .map(([id, reducer]) => ([id.split("/")[1].replace(/\.[jt]sx?$/, ""), reducer]))
  .fromPairs()
  .value()

export default combineReducers(reducers)
